import { render, staticRenderFns } from "./CustomerSearchTable.vue?vue&type=template&id=0ee3c2f3&scoped=true&"
import script from "./CustomerSearchTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerSearchTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee3c2f3",
  null
  
)

export default component.exports